import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./linkwithbank.css";
import BackArrow from "../../../../components/backArrow";
import url from "../../../../config/axios";
import { useSelector } from "react-redux";
import {useNavigate} from "react-router-dom"
import { FailedNotify, SuccessNotify } from "../../../../constants/tostify";
import { useDropzone } from "react-dropzone";
import { publishImage } from "../../../../helpers/imageupload";
import { useEffect } from "react";
const LinkBankAccount = () => {
  const navigate=useNavigate();
  const {name}=useSelector((state) => state.user);
    const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
 const [marketerdata,setMarketerdata]=useState('')
const [bankinfo,setBankinfo]=useState({

 accountHolderName: "",
  bankName: "",
  iban: "",
  branchName: "",
  cnic: "",
  documentUrl: ""
})

  const handlePost = () => {
url.post(`marketingagent/payment?marketerId=${marketerdata?.marketerId}`, bankinfo).then(async (res) => {

  if(res.data.success){
    SuccessNotify(res.data.message);
    navigate("/marketing-setting")
  }
}).catch((err) => {
  FailedNotify(err?.response?.data?.message);
});
  };

  const handleChange = (e) => {
    setBankinfo((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

const onDrop = async (acceptedFiles) => {
  try {
    setIsUploading(true);
    setUploadProgress(0);

    const abc = await publishImage(acceptedFiles, (percent) => {
      setUploadProgress(percent);
    });

    setBankinfo((prev) => ({
      ...prev,
      documentUrl: abc?.[0] || "",
    }));

  } catch (error) {
    FailedNotify("Failed! Try Again");
  } finally {
    setIsUploading(false);
    setUploadProgress(0);
  }
};

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  useEffect(() => {
  url.get(`marketingagent?userid=${name?._id}`).then((response) => {
    setMarketerdata(response?.data?.data[0]);
  })
}, []);

  return (
    <Row className="p-4">
      <div className="screenHeight marketing-height-manage p-3">
        <Col lg={7} md={7} sm={12} xs={12} className="p-5 pt-0">
          {/* Back Button */}
          <BackArrow />
          <h3 className="main-title mt-2">Link Your Bank Account</h3>
          <p className="main-subtitle mb-3">
            Securely link your bank account to receive payments. Ensure all
            details are accurate to avoid delays.
          </p>

          <Form>
            {/* Account Holder Name */}
            <Form.Group className="mb-4">
              <Form.Label className="field-label">
                Account Holder Name
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter account holder name"
                className="custom-input"
                name="accountHolderName"
                onChange={handleChange}
              />
            </Form.Group>

            {/* Bank Name */}
            <Form.Group className="mb-4">
              <Form.Label className="field-label">Bank Name</Form.Label>
              <Form.Select className="custom-input custom-select" name="bankName"
                onChange={handleChange}>
                <option selected disabled>Select bank</option>
                <option>HBL</option>
                <option>ABL</option>
                <option>MCB</option>
              </Form.Select>
            </Form.Group>

            {/* Account Number */}
            <Form.Group className="mb-4">
              <Form.Label className="field-label">Account Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter account number"
                className="custom-input"
              />
            </Form.Group>

            {/* IBAN */}
            <Form.Group className="mb-4">
              <Form.Label className="field-label">IBAN</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter IBAN"
                className="custom-input"
                name="iban"
                onChange={handleChange}
              />
            </Form.Group>

            {/* Branch Name */}
            <Form.Group className="mb-4">
              <Form.Label className="field-label">
                Branch Name <span className="optional">(Optional)</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter branch name"
                className="custom-input"
                name="branchName"
                onChange={handleChange}
              />
            </Form.Group>

            {/* CNIC */}
            <Form.Group className="mb-4">
              <Form.Label className="field-label">CNIC</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter CNIC"
                className="custom-input"
                name="cnic"
                onChange={handleChange}
              />
            </Form.Group>

            {/* Upload Document */}

{isUploading ? (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(255,255,255,0.7)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  borderRadius: "0.5rem",
                }}
              >
                <div
                  className="spinner-border text-primary"
                  style={{ width: "1.5rem", height: "1.5rem" }}
                  role="status"
                ></div>
                <small className="mt-1">{uploadProgress}%</small>
              </div>
            ) : (
              <>
                 <Form.Group className="mb-5" {...getRootProps()}>
              <Form.Label className="field-label">
                Upload Document <span className="optional">(Optional)</span>
              </Form.Label>




              
              <div className="upload-area">
                <span>Upload document</span>
              </div>
            </Form.Group>

              </>
            )}







            
           
            {/* Action Buttons */}
            <div className="d-flex flex-column flex-sm-row gap-3 mb-4">
              <Button className="save-btn flex-fill" onClick={handlePost}>Save Bank Details</Button>
              <Button variant="light" className="cancel-btn flex-fill" onClick={()=>navigate('/marketing-setting')}>
                Cancel / Back
              </Button>
            </div>

            <p className="security-footer text-center">
              Your data is encrypted and securely stored. Please update your
              bank details if there are any changes.
            </p>
          </Form>
        </Col>

        <Col lg="5" xl="5" sm="12" xs="12" className="marketing-sidebar-height">
          <div className="info-card mb-4">
            <h3 className="info-card-title">Why Link Your Bank Account?</h3>
            <p className="info-card-text">
              Linking your bank account ensures timely and secure payments for
              your marketing efforts. It also allows for easy tracking of your
              earnings and payment history.
            </p>
          </div>

          <div className="info-card">
            <h3 className="info-card-title">Security Information</h3>
            <p className="info-card-text">
              We use industry-standard encryption to protect your bank account
              information. Your data is never shared with third parties without
              your consent. You can update your bank details at any time.
            </p>
          </div>
        </Col>
      </div>
    </Row>
  );
};

export default LinkBankAccount;
